module.exports = __webpack_public_path__ + "assets/images/25HL.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25HL.png
// module id = 1295
// module chunks = 1